import React from 'react'
import { NavLink } from 'react-router-dom'
import { FleetPage, Notice } from '../../../../shared/sso-workspace/fleet-page'
import { useNotifyOpsAccess } from './access'
import './notify.scss'

export const TABS = [
  { to: '/admin/notify', label: 'Overview', exact: true },
  { to: '/admin/notify/deliveries', label: 'Delivery log' },
  { to: '/admin/notify/outbox', label: 'Outbox & events' },
  { to: '/admin/notify/dead-letter', label: 'Dead letter' },
  { to: '/admin/notify/captures', label: 'Captured payloads' },
  { to: '/admin/notify/rollout', label: 'Rollout' },
  { to: '/admin/notify/catalogue', label: 'Catalogue' },
  { to: '/admin/notify/credentials', label: 'Push credentials' },
  { to: '/admin/notify/test-send', label: 'Test send' }
]

// The section's frame: the title, its purpose, the tabs and, for someone
// who can only read, why nothing can be changed.
export const NotifyPage = ({ children }) => {
  const access = useNotifyOpsAccess()
  return (
    <FleetPage title="Notifications" purpose="Every notification the platform raises, where it went and what happened to it: inbox, email and push.">
      <nav className="sw-tabs" aria-label="Notifications">
        {TABS.map(t =>
          <NavLink key={t.to} to={t.to} exact={t.exact} activeClassName="active">{t.label}</NavLink>)}
      </nav>
      {access.reason && <Notice tone="warn" role="status">{access.reason}</Notice>}
      {children}
    </FleetPage>
  )
}
